import { useEffect, useState } from "react";
import { load_production_planner_data_from_backend, upload_open_po_file } from "../utilis/productionPlannerServices";
import { CustomDataGrid } from "../../../common/components/Table/CustomDataGrid";
import { prodPlannerGridColumns } from "../utilis/prodPlannerGridColumns";
import { Box } from "@mui/material";
import { FileUploaderRipik } from "../../HomePage/components/FileUploaderRipik";

const TabContent = ({ tabName, set_open_snackbar_with_message }) => {
    // const gridRef = useGridApiRef();
    const [data, setData] = useState([]);
    const columnsData = Object.values(prodPlannerGridColumns);
    const [file, set_file] = useState(null);

    const handle_file_upload = async (uploaded_file) => {
        await upload_open_po_file(uploaded_file, tabName).then((res) => {
            set_open_snackbar_with_message({
                message: res,
                open: true,
                severity: "success"
            });
            load_production_planner_data_from_backend(data, setData, tabName);
        }).catch((error) => {
            set_open_snackbar_with_message({
                message: error,
                open: true,
                severity: "error"
            });
        });
    };
    // gridRef.current.tabName = tabName;
    // console.log(gridRef);
    // console.log(data);
    useEffect(() => {
        load_production_planner_data_from_backend(data, setData, tabName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabName]);
    return (
        <>
            <Box>
                <FileUploaderRipik file={file} file_update_function={(uploaded_file) => {
                    set_file(uploaded_file);
                    console.log(uploaded_file);
                    handle_file_upload(uploaded_file);
                }} upload_message={`Upload ${(tabName === "CB" ? "In Process" : tabName === "FP" ? "FP Pack" : tabName)} Open PO File Here`} />
            </Box>
            {
                data && <CustomDataGrid
                    columns={columnsData}
                    rows={data || []}
                    sx={{
                        height: "700px"
                    }}
                />
            }


        </>
    );
};
export default TabContent;